import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
import { truncate } from 'flarum/common/utils/string';
export default class PostAwaitingApprovalNotification extends Notification {
  icon() {
    return 'fas fa-user-check';
  }
  href() {
    const content = this.attrs.notification.content();
    const near = content?.postNumber;
    return app.route(near && near !== 1 ? 'discussion.near' : 'discussion', {
      id: content?.discussionId,
      near: near && near !== 1 ? near : undefined
    });
  }
  content() {
    const notification = this.attrs.notification;
    const post = notification.subject();
    return app.translator.trans('hli-approval-notify.forum.notifications.post_awaiting_approval_text', {
      user: notification.fromUser(),
      title: post?.discussion?.()?.title() || ''
    });
  }
  excerpt() {
    const post = this.attrs.notification.subject();
    return truncate(post?.contentPlain?.() || '', 200);
  }
}
flarum.reg.add('hli-approval-notify', 'forum/components/PostAwaitingApprovalNotification', PostAwaitingApprovalNotification);